import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/ui/button';
import TabGroup from 'src/components/ui/tabgroup';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

import { NotificationTab } from '../../types';

type NotificationPanelTabsProps = {
  activeTab: NotificationTab;
  onTabChange: (tab: NotificationTab) => void;
  totalCount: number;
  unreadCount: number;
  onDismissAll?: () => void;
  onMarkAllAsRead?: () => void;
};

const NotificationPanelTabs = ({
  activeTab,
  onTabChange,
  totalCount,
  unreadCount,
  onDismissAll,
  onMarkAllAsRead
}: NotificationPanelTabsProps) => {
  const { t } = useTranslation();

  const tabList = [
    {
      text: t(T.all),
      value: NotificationTab.All,
      selected: activeTab === NotificationTab.All,
      badgeText: String(totalCount),
      onClick: () => onTabChange(NotificationTab.All)
    },
    {
      text: t(T.unread),
      value: NotificationTab.Unread,
      selected: activeTab === NotificationTab.Unread,
      badgeText: String(unreadCount),
      onClick: () => onTabChange(NotificationTab.Unread)
    }
  ];

  return (
    <div className="tw:flex tw:flex-nowrap tw:items-center tw:justify-between tw:px-m tw:py-s tw:border-b tw:border-border-secondary tw:gap-2">
      <TabGroup tabList={tabList} className="tw:flex-nowrap" />

      <div className="tw:flex tw:items-center tw:content-center tw:flex-wrap tw:p-0 tw:shrink-0 tw:gap-l">
        {totalCount > 0 && (
          <Button hierarchy="linkDestructive" className="tw:p-0" onClick={onDismissAll}>
            {t(T.clearAll)}
          </Button>
        )}

        {unreadCount > 0 && (
          <Button hierarchy="link" className="tw:p-0" onClick={onMarkAllAsRead}>
            {t(T.markAllAsRead)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default NotificationPanelTabs;
